module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-list-item', {
    ref: "colorPicker",
    staticClass: "ql-layer-menu-item"
  }, [_c('md-button', {
    staticClass: "ql-color-picker-choice",
    style: (_vm.style()),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.toggleVisibility($event)
      }
    }
  }, [(!_vm.viewable) ? _c('md-icon', [_vm._v("visibility_off")]) : _vm._e(), _vm._v(" "), (_vm.viewable && !_vm.showNotes) ? _c('md-icon', [_vm._v("speaker_notes_off")]) : _c('md-icon')], 1), _vm._v(" "), (_vm.editable) ? _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.saveTitle($event)
      },
      "keyup": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.keyPress($event)
      }
    }
  }, [(!_vm.editing) ? _c('span', {
    on: {
      "click": function($event) {
        _vm.edit()
      }
    }
  }, [_vm._v(_vm._s(_vm.layer.title) + "\n            "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("click to edit title")])], 1) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('md-input-container', [_c('md-input', {
    attrs: {
      "value": _vm.layer.title
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    },
    model: {
      value: (_vm.layer.title),
      callback: function($$v) {
        _vm.$set(_vm.layer, "title", $$v)
      },
      expression: "layer.title"
    }
  })], 1) : _vm._e()], 1) : _c('span', {
    staticStyle: {
      "width": "100%",
      "padding-left": "15px"
    }
  }, [_vm._v(" " + _vm._s(_vm.layer.title) + "\n        "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("No Edit Permissions")])], 1), _vm._v(" "), (_vm.editing) ? _c('md-button', {
    staticClass: "md-icon-button md-list-action",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.saveTitle($event)
      }
    }
  }, [_c('md-icon', [_vm._v("save")])], 1) : _vm._e(), _vm._v(" "), _c('md-list-expand', [_c('md-list', {
    staticClass: "sub-list"
  }, [(_vm.viewable) ? _c('md-list-item', {
    on: {
      "click": _vm.hide
    }
  }, [_vm._v("\n                Hide Layer\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.viewable) ? _c('md-list-item', {
    on: {
      "click": _vm.show
    }
  }, [_vm._v("\n                Show Layer\n            ")]) : _vm._e(), _vm._v(" "), (_vm.showNotes) ? _c('md-list-item', {
    on: {
      "click": _vm.hideText
    }
  }, [_vm._v("\n                Hide Text\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.showNotes) ? _c('md-list-item', {
    on: {
      "click": _vm.showText
    }
  }, [_vm._v("\n                Show Text\n            ")]) : _vm._e(), _vm._v(" "), (_vm.editable) ? _c('md-list-item', [_vm._v("\n                Change Color\n                "), _c('md-list-expand', [_c('md-list', [_c('md-list-item', [_c('color-picker', {
    on: {
      "input": _vm.pickColor
    },
    model: {
      value: (_vm.colors),
      callback: function($$v) {
        _vm.colors = $$v
      },
      expression: "colors"
    }
  }), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("click to change color theme")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.editable) ? _c('md-list-item', {
    on: {
      "click": _vm.deleteLayer
    }
  }, [_vm._v("\n                Delete this layer \n                "), _c('md-icon', [_vm._v("delete")])], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36feb818","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/layers/layer.vue
// module id = 646
// module chunks = 2